import { useEffect, useState, useContext, useReducer } from "react"
import { useHistory } from "react-router-dom"
import { GlobalContext } from "@Context/context/GlobalContext"
import { ItemsOrderType, ItemOrderType, ProcessShippingGroupActionType } from "@Types/OrderType"
import { IItems } from "@Interfaces/IItemsOrder"
import Logger from "@Classes/Logger"
import {
  executeShipingGroupAction,
  retryGetShippinGroupElocker,
} from "@Services/ShippingGroupService"
import { MESSAGE_RETIES_ELOCKER, NOTIFY_PICKING } from "@Helpers/constHelper"
import { TransactionCodeEnum } from "@Enums/TransactionCodeEnum"
import { EShippinggroupAction } from "@Enums/shippinggroupEmun"
import useCancelToken from "@Hooks/UseCancelToken"
import { DeliveryTypeEnum, ShippingTypeEnum } from "@Enums/OrderEnum"
import pickingReducer, { initialStatePicking } from "./PickingReducer"

const useConfirmOrder = ({
  order,
  itemsOrder,
  shippingGroupId,
  setFinishedShippingGroupAction,
}: { itemsOrder: ItemsOrderType } & ProcessShippingGroupActionType) => {
  const { notification, errorHander } = useContext(GlobalContext)

  const [pickingTransition, dispachPickingTransition] = useReducer(
    pickingReducer,
    initialStatePicking,
  )
  const [itemsAllProcessed, setItemsAllProcessed] = useState(false)
  const [loadingConfirm, setLoadinfConfirm] = useState(false)
  const [loadingCancel, setLoadingCancel] = useState(false)

  const history = useHistory()

  const { isCancel, newCancelToken } = useCancelToken()

  useEffect(() => {
    if (pickingTransition.isEditing) {
      setItemsAllProcessed(false)
      return
    }
    if (itemsOrder?.length === pickingTransition.processItems.length) {
      setItemsAllProcessed(true)
    }
  }, [pickingTransition.processItems, pickingTransition.isEditing, itemsOrder])

  const getCurrentNextItem = () => {
    let currentItem: ItemOrderType = null
    let nextItems: Array<IItems> = []

    if (itemsOrder && pickingTransition.itemIdexActive > -1) {
      currentItem = itemsOrder[pickingTransition.itemIdexActive]

      nextItems = itemsOrder.filter(
        ({ sku }) => !pickingTransition.processItems.some((item) => item.sku === sku),
      )
    }

    return {
      currentItem,
      nextItems,
    }
  }

  const handleClickConfirmOrder = async () => {
    try {
      const confirmItems = pickingTransition.processItems.filter(({ isConfirm }) => isConfirm)

      if (confirmItems.length === 0) {
        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "No hay ningún producto para confirmar",
            title: NOTIFY_PICKING,
            type: "info",
          },
        })
        return
      }
      setLoadinfConfirm(true)

      const {
        data: { code },
      } = await executeShipingGroupAction({
        action: EShippinggroupAction.accept,
        shippingGroupId,
        requestBody: {
          seller: {
            id: "1",
          },
          items: confirmItems.map(({ sku, quantity, custom }) => ({
            sku,
            quantity,
            custom,
          })),
        },
      })

      //picking success TODO:: case error
      if (code === TransactionCodeEnum.ok) {
        // verify await get info elocker

        if (
          order &&
          order.shippingType === ShippingTypeEnum.SP &&
          order.deliveryType === DeliveryTypeEnum.ED
        ) {
          Logger.info(
            `Elocker retries (ORDEN_ID ${order.id}) START ${new Date().toLocaleTimeString()}`,
          )

          const successGetElocker = await retryGetShippinGroupElocker({
            orderId: order.id,
            shippingGroupId,
            cancelToken: newCancelToken(),
          })

          Logger.info(
            `Elocker retries (ORDEN_ID ${order.id}) END ${new Date().toLocaleTimeString()}`,
          )
          if (!successGetElocker) {
            notification?.dispatch({
              type: "ADD_NOTIFICATION",
              payload: {
                message: MESSAGE_RETIES_ELOCKER,
                title: NOTIFY_PICKING,
                type: "info",
              },
            })
          }
        }

        setFinishedShippingGroupAction(true)
        setLoadinfConfirm(false)

        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Orden confirmada correctamente",
            title: NOTIFY_PICKING,
            type: "success",
          },
        })
      }
    } catch (error: any) {
      Logger.error(error)
      setLoadinfConfirm(false)

      if (isCancel(error)) return
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  const handleClickCancelOrder = async (action: EShippinggroupAction) => {
    try {
      setLoadingCancel(true)
      const {
        data: { code },
      } = await executeShipingGroupAction({
        shippingGroupId,
        action, 
      })

      setLoadingCancel(false)

      //picking success TODO:: case error
      if (code === TransactionCodeEnum.ok) {
        notification?.dispatch({
          type: "ADD_NOTIFICATION",
          payload: {
            message: "Orden rechazada correctamente",
            title: NOTIFY_PICKING,
            type: "success",
          },
        })

        history.goBack()
      }
    } catch (error: any) {
      Logger.error(error)
      setLoadingCancel(false)
      errorHander?.dispatch({ hasError: true, code: error.response?.status })
    }
  }

  const backToScan = () => {
    setItemsAllProcessed(false)
    dispachPickingTransition({ type: "RESET_PICKING" })
  }

  const { currentItem, nextItems } = getCurrentNextItem()

  return {
    currentItem,
    nextItems,
    itemsAllProcessed,
    handleClickConfirmOrder,
    loadingConfirm,
    handleClickCancelOrder,
    loadingCancel,
    backToScan,
    dispachPickingTransition,
    pickingTransition,
  }
}

export default useConfirmOrder
